(() => {
    if (window._addressDisplayLoaded) return;
    window._addressDisplayLoaded = true;

    const METHOD = "klaviyo_integration.apis.address_display.get_custom_address_display";
    const DOCTYPES = ["Quotation", "Sales Order", "Sales Invoice"];

    async function fetchDisplay(addressName, customerName, context, variant = "desk") {
        if (!addressName) return "";
        return new Promise((resolve) => {
            frappe.call({
                method: METHOD,
                args: { address_name: addressName, customer_name: customerName, context, variant },
                freeze: false,
                callback: function (r) {
                    resolve(r?.message || "");
                },
                error: function () {
                    resolve("");
                }
            });
        });
    }

    function getCustomerName(frm) {
        return frm.doc?.customer_name || frm.doc?.customer || "";
    }

    function stripEditButton(html = "") {
        return html.replace(/<(a|button)\b[^>]*class=(?:"[^"]*?\bedit-btn\b[^"]*?"|'[^']*?\bedit-btn\b[^']*?')[^>]*>[\s\S]*?<\/\1>/gi, "");
    }

    function setHtml(frm, htmlField, html) {
        const field = frm.get_field(htmlField);
        if (!field) return;
        
        field.options = html || "";
        if (field.$wrapper) {
            field.$wrapper.html(html || "");
            if (window.lucide && typeof window.lucide.createIcons === 'function') {
                window.lucide.createIcons({ root: field.$wrapper[0] });
            }
        }
    }

    async function updateDisplay(frm, linkField, htmlField, context) {
        if (!frm.fields_dict?.[htmlField]) return;
        const linkDf = frm.fields_dict?.[linkField]?.df;
        if (!linkDf || linkDf.fieldtype !== "Link") return;

        const addressName = frm.doc?.[linkField];
        if (!addressName) {
            await setHtml(frm, htmlField, "");
            return;
        }

        const currentName = addressName;
        const customerName = getCustomerName(frm);
        let html = await fetchDisplay(currentName, customerName, context);

        if (linkField === "shipping_address_name" && frm.doc?.docstatus !== 0) {
            html = stripEditButton(html);
        }

        if ((frm.doc?.[linkField] || "") !== currentName) return;

        await setHtml(frm, htmlField, html);
    }

    async function refreshAll(frm) {
        await Promise.all([
            updateDisplay(frm, "customer_address", "custom_address_html", "billing"),
            updateDisplay(frm, "shipping_address_name", "custom_shipping_address_html", "shipping"),
            updateDisplay(frm, "shipping_address_name", "custom_shipping_contact_html", "shipping_contact"),
            updateDisplay(frm, "custom_return_address_name", "custom_return_address_html", "return"),
            updateDisplay(frm, "custom_return_address_name", "custom_return_contact_html", "return_contact"),
        ]);
    }


    function bindEditButtons(frm) {
        if (frm.__address_edit_bound) return;
        frm.__address_edit_bound = true;

        frm.wrapper.addEventListener("click", async (e) => {
            const link = e.target.closest("a.edit-btn[data-address-name]");
            if (!link) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const addressName = link.dataset.addressName;
            if (!addressName) return;

            if (!frappe.ui?.form?.make_quick_entry) {
                frappe.msgprint(__("Quick Edit is unavailable for Address."));
                return;
            }

            try {
                await frappe.model.with_doc("Address", addressName);
                const doc = frappe.get_doc("Address", addressName);
                frappe.ui.form.make_quick_entry(
                    "Address",
                    async () => {
                        await refreshAll(frm);
                    },
                    null,
                    doc
                );
            } catch (err) {
                console.warn("Quick edit failed", err);
                frappe.msgprint(__("Unable to open Address quick edit."));
            }
        });
    }

    function register(doctype) {
        if (!frappe.ui?.form?.on) return;
        frappe.ui.form.on(doctype, {
            refresh(frm) {
                refreshAll(frm);
                bindEditButtons(frm);
            },
            customer_address(frm) {
                updateDisplay(frm, "customer_address", "custom_address_html", "billing");
            },
            shipping_address_name(frm) {
                updateDisplay(frm, "shipping_address_name", "custom_shipping_address_html", "shipping");
                updateDisplay(frm, "shipping_address_name", "custom_shipping_contact_html", "shipping_contact");
            },
            custom_return_address_name(frm) {
                updateDisplay(frm, "custom_return_address_name", "custom_return_address_html", "return");
                updateDisplay(frm, "custom_return_address_name", "custom_return_contact_html", "return_contact");
            },
        });
    }

    if (frappe.ui?.form?.on) {
        DOCTYPES.forEach(register);
    }

    // Export for direct usage in website components and custom handlers
    window.fetchDisplay = fetchDisplay;
    window.fetchAddressDisplay = fetchDisplay;
    window.stripEditButton = stripEditButton;
})();